import { FC, useEffect, useState } from "react"
import { Divider } from "@material-ui/core"
import { Clientes, FinanceiraType, FinanciamentoParcela, FinanciamentoSimulacao, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { Boleto } from "../../boleto/Boleto";
import { CollectionUtil } from "src/framework/commons";
import { STATUS_CODE } from "src/framework/providers/api";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { Financeiras } from "../../financiamento/Financeiras";
import { BOLETO_FINANCIAMENTO } from "src/constants";
import { FullWidthButton } from "src/framework/components/buttons";
import { FaBarcode } from "react-icons/fa";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";
import { AiFillBank } from "react-icons/ai";
import { InputMoney } from "src/framework/components/forms";
import "./styles.scss";
interface BoletoFinanciamentoProperties {
    pedido: PedidoType | null;
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType, fecharPagamento: boolean) => void;
}

const BoletoFinanciamento: FC<BoletoFinanciamentoProperties> = ({
    pedido,
    onConfirmar
}) => {
    const [valorBoleto, setValorBoleto] = useState<number>(0);
    const [pedidoFinanciamento, setPedidoFinanciamento] = useState<PedidoType | null>(null);
    const [showFinanciamento, setShowFinanciamento] = useState<boolean>(false)
    const [disabledConfirmar, setDisableConfirmar] = useState<boolean>(true);
    const [pedidoPagamento, setPedidoPagamento] = useState<PedidoPagamento | null>(null);
    

    const [dadosCliente, setDadosCliente] = useState<Clientes | null>(null);
    
    const _valorPendente = (): number | null => {
        if (pedido) {
            let _valorEmPagamento: number = valorBoleto
            const _valorPendente = Number(((pedido?.valor_pendente || pedido?.valor_pagamento) - _valorEmPagamento).toFixed(2))
            return _valorPendente;
        }
        return null;
    }

     /** Métodos **/
     const getDadosCliente = async (): Promise<void> => {
        const response = await pagamentoProvider.obtemClientePedido(String(pedido?.codigo_venda))

        if (response.statusCode === STATUS_CODE.OK) {
            setDadosCliente(response?.data || null);
        }
    }

    const init = async (): Promise<void> => {
        Promise.all([
            getDadosCliente(),
            setPedidoFinanciamento(CollectionUtil.merge({}, pedido))
        ]);

    }

    useEffect(() => {
        setValorBoleto(Number(pedido?.valor_pendente || "0"))
        init()
    }, [])

    return <div className="BoletoFinanciamento">
        <HeaderFormaPagamento 
            icon={<><FaBarcode /></>}
            title={<>Boleto</>}
        />

        <Boleto 
            disabled={showFinanciamento}
            valor={valorBoleto}
            onChangeValue={(value) => {
                if (pedido) {
                    setValorBoleto(value > (pedido.valor_pedido || pedido?.valor_pagamento || 0.0) ? (pedido.valor_pedido || pedido?.valor_pagamento || 0.0) : value)
                }
            }}
            sizes={"X12 S6"}
        />

        {showFinanciamento && <>
            <div className="row">
                <div className="X12">
                    <HeaderFormaPagamento 
                        icon={<><AiFillBank /></>}
                        title={<>Financiamento via plataforma</>}
                        subTitle="Faça a simulação de financiamento"
                        style={{marginTop: "28px"}}
                    />
                </div>
            </div>
            <div className="row">
                <div className="X12 S6 M4">
                    <InputMoney 
                        label="Valor a financiar"
                        value={pedidoFinanciamento?.valor_pagamento}
                        disabled={true}
                    />
                </div>
            </div>
            <Financeiras
                solo={false}
                pedido={pedidoFinanciamento}
                disabledConfirmar={false}
                dadosCiente={dadosCliente}
                onChange={(simulacao: FinanciamentoSimulacao | null, financeira: FinanceiraType | null, parcela: FinanciamentoParcela | null) => {
                    if (simulacao === null && financeira === null &&  parcela === null) {
                            setPedidoPagamento(null)
                            setDisableConfirmar(true)
                            return;
                    }
                    if (simulacao && pedido && pedidoFinanciamento && financeira && parcela) {
                        const _pedidoPagamento: PedidoPagamento = {
                            forma_pagamento: BOLETO_FINANCIAMENTO.id,
                            pedido: pedido.id,
                            itens: {
                                financiamento: [{
                                    financeira: financeira.id,
                                    simulacao: simulacao.simulacao_id,
                                    valor: simulacao.total_liberado,
                                    valor_original: Number(pedidoFinanciamento?.valor_pagamento),
                                    valor_parcela: Number(parcela?.valor_parcela),
                                    valor_entrada: Number(parcela?.valor_entrada),
                                    parcelas: Number(parcela?.parcela),
                                    taxa: Number(parcela?.taxa_juros),
                                    carencia: Number(parcela?.dias_carencia_primeiro_pagamento),
                                }],
                                boletos: [
                                    {
                                        valor: valorBoleto,
                                        valor_original: valorBoleto
                                    }
                                ]
                            }
                        }
                        setPedidoPagamento(_pedidoPagamento)
                        setDisableConfirmar(false)
                    }
                }}
            />
        </>}

        <div className="row">
           {!showFinanciamento && <div className="X12 M6">
                <FullWidthButton 
                    text="Adicionar boleto"
                    disabled={(valorBoleto === 0 || valorBoleto === pedido?.valor_pagamento)}
                    color="secondary"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        const _valor: number | null = _valorPendente();
                        if (_valor !== null) {
                            const _pedidoFinanciamento = CollectionUtil.merge({}, pedidoFinanciamento)
                            if (_pedidoFinanciamento) {
                                _pedidoFinanciamento.valor_pagamento = _valor;
                            }
                            setPedidoFinanciamento(_pedidoFinanciamento)
                            setShowFinanciamento(true)
                        }
                    }}
                />
            </div>}
            {showFinanciamento && <div className="X12 M6">
                <FullWidthButton 
                    text="Alterar valor do boleto"
                    color="default"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        setShowFinanciamento(false)
                        setDisableConfirmar(true)
                    }}
                />
            </div>}
            <div className="X12 M6">
                <FullWidthButton 
                    disabled={disabledConfirmar}
                    text="Confirmar"
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        if (pedidoPagamento) {
                            onConfirmar(pedidoPagamento, BOLETO_FINANCIAMENTO.id as any, true)
                        }
                    }}
                />
            </div>
        </div>
    </div>
}

export { BoletoFinanciamento }